import React, { useMemo } from 'react';
import _ from 'underscore';
import { Constants } from '@bingads-webui-clientcenter/entity-utils';
import { StringUtils } from '@bingads-webui-clientcenter/common-utils';
import { TaxTypeFormPropTypes } from '../shapes';
import { GlobalTaxForm } from './global-taxform';
import { EmptyTaxForm } from './empty-taxform';
import { registerTaxform } from '../taxform-store';
import { EmptyViewTaxForm } from './viewtaxforms/empty-viewtaxform';
import { AOTaxViewTaxForm } from './viewtaxforms/angola-viewtaxform';
import { CustomValidateItems } from '../validator';
import { withViewTaxFormWithFilledEmptyTaxValue, withTaxFormByPilot, getTaxTypeLabel } from '../utils';
import { GlobalTaxIdHelpPopUpId, GlobalTaxIdCountryCodeToPilots } from '../constants';

const {
  TaxAOVatNumberRegExp, TaxType, TaxLabelFormat, CountryCode,
} = Constants;
const taxIdValidator = _.partial(StringUtils.regexTest, TaxAOVatNumberRegExp);
const taxSchemaGetter = () => ({
  name: 'Angola Taxation Validation Schema',
  type: 'object',
  properties: {
    [TaxType.VatNumber]: {
      type: 'string',
      required: false,
      helpPopupTopic: GlobalTaxIdHelpPopUpId,
    },
  },
});

const AOTaxForm = ({
  i18n,
  onValidate,
  showLineByLineFormGroup,
  alwaysShowError,
  data,
  mtData,
  taxCertification,
  mtTaxCertification,
  urlBuilder,
  disabled,
  permissions,
}) => {
  const vatValidatorErrorMessage = useMemo(() => i18n.getString(CustomValidateItems.AngolaVATFormatValidation), [i18n]);
  const vatLabel = useMemo(() => getTaxTypeLabel(TaxType.VatNumber, i18n, { labelFormat: TaxLabelFormat.RequiredForBusiness, countryCode: CountryCode.AO }, permissions), [i18n, permissions]);

  return (
    <GlobalTaxForm
      i18n={i18n}
      onValidate={onValidate}
      taxSchemaGetter={taxSchemaGetter}
      vatLabel={vatLabel}
      showLineByLineFormGroup={showLineByLineFormGroup}
      vatValidatorErrorMessage={vatValidatorErrorMessage}
      alwaysShowError={alwaysShowError}
      data={data}
      mtData={mtData}
      taxCertification={taxCertification}
      mtTaxCertification={mtTaxCertification}
      urlBuilder={urlBuilder}
      disabled={disabled}
      taxIdValidator={taxIdValidator}
      showTaxCert={false}
    />
  );
};

AOTaxForm.propTypes = TaxTypeFormPropTypes;

const pilotFlag = GlobalTaxIdCountryCodeToPilots.AO;
const TaxForm = withTaxFormByPilot({ pilotFlag, PilotForm: AOTaxForm, DefaultForm: EmptyTaxForm });
const ViewTaxForm = withTaxFormByPilot({ pilotFlag, PilotForm: AOTaxViewTaxForm, DefaultForm: EmptyViewTaxForm });

registerTaxform('/AO/', TaxForm, withViewTaxFormWithFilledEmptyTaxValue({ ViewTaxForm, getTaxSchema: taxSchemaGetter }));
